module.exports = __webpack_public_path__ + "img/image-placeholder.d8adb34f.jpg";